import getPersonEventId from './personEventId'

const api = {
  getPersonEventId: {
    key: 'FETCH_PERSON_EVENT_ID_KEY',
    fn: getPersonEventId,
  },
}

export default api
